import React, { PureComponent } from 'react';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';

export default class PhantomTrigger extends PureComponent {
    componentDidMount() {
        Mixpanel.track( 'Loaded a Page' );
    }
    render() {
        return (
            <div className='phantom-trigger' style={ { width: '1px', height: '1px', position: 'absolute', bottom: '-10px', left: '-10px' } } />
        );
    }
}
